module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_GeographicLocation_16"],"path":[{"$":{"d":"M14.64,7.45,9,10.29V4.95a2.5,2.5,0,1,0-1,0v5.31L1.21,6.8.66,7.86,7.21,11.2.73,14.46l.54,1.07,13.91-7Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_GeographicLocation_16.svg
// module id = KPxV
// module chunks = 1